import type { Mode } from '@/types'
import { getApiLink } from './utils/api-urls'
import { AXIOS_DEFAULT_OPTIONS } from './utils/consts'
import createApiClient from './utils/create-api-client'
import type { AxiosInstance } from 'axios'

let workflowsApiClient: null | AxiosInstance = null

export function createOrchestratorApi() {
    if (workflowsApiClient) {
        // eslint-disable-next-line no-console
        console.warn('api client already created')
        return
    }

    workflowsApiClient = createApiClient({
        ...AXIOS_DEFAULT_OPTIONS,
    })
}

export function updateOrchestratorApi(mode: Mode) {
    if (workflowsApiClient) {
        workflowsApiClient.defaults.baseURL = getApiLink('orchestrator', mode)
    }
}

export function useOrchestratorApi() {
    if (workflowsApiClient) {
        return workflowsApiClient
    }

    throw new Error('api client hasn\'t been created')
}
